import doLog from "./log";

const isIframe = window.self !== window.top;

const postFormData = (target: HTMLFormElement) => {
  const formData: any = new FormData(target);
  const entries: Array<[string, any]> = Array.from(formData.entries());
  const jsonObject = Object.fromEntries(entries);
  // 提交地址
  jsonObject.action = target.action;
  doLog('/sc.detail.startOrder');

  window.parent.postMessage({
    from: 'quickView',
    event: 'submit',
    action: JSON.stringify(jsonObject)
  }, '*');
}

const postLogin = () => {
  window.parent.postMessage({
    from: 'quickView',
    event: 'login',
  }, '*');
}

const postUrl = () => {
  const url = window.location;
  const urlParams = new URLSearchParams(url.search);
  urlParams.delete('pagetype');
  urlParams.delete('channel');
  doLog('/sc.detail.sku_viewdetail');
  window.parent.postMessage({
    from: 'quickView',
    event: 'url',
    action: `${url.origin}${url.pathname}?${urlParams.toString()}${url.hash}`
  }, '*');
}

const postLoad = () => {
  window.parent.postMessage({
    from: 'quickView',
    event: 'loaded',
  }, '*');
}

const postPo = (url: string) => {
  doLog('/sc.detail.sendOrderRequest');
  window.parent.postMessage({
    from: 'quickView',
    event: 'po',
    action: url
  }, '*');
}
export { isIframe, postFormData, postPo, postLogin, postUrl, postLoad };
